import type { HTMLAttributes } from "react";
import React from "react";
import type { ValidationError } from "@tanstack/react-form";

import { Errors } from "@/components/form/field-errors";
import { cn } from "@/lib/utils";

export interface InsideLabelFieldProps extends HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  infos?: string;
  errors?: Array<ValidationError>;
  gridRow?: boolean;
}

const InsideLabelField = ({
  children,
  infos,
  errors,
  className,
  gridRow,
  ...props
}: InsideLabelFieldProps) => {
  return (
    <div
      className={cn(
        "flex flex-col items-start w-full space-y-2",
        { "col-span-full": gridRow },
        className
      )}
      {...props}
    >
      {children}
      <Errors>{errors}</Errors>
      {infos && <p className="text-xs text-muted-foreground">{infos}</p>}
    </div>
  );
};

export default InsideLabelField;
